<script setup lang="ts">
import { computed, useAttrs } from 'vue'

interface Props {
  form?: any,
  errors?: any,
  name: string,
}

const props = defineProps<Props>()
const attrs = useAttrs()
const _form = computed(() => props.form)
const _errors = computed(() => props.errors)

const showError = computed(() => {
  return _form.value?.code?.invalid || (_errors.value && _errors.value[props.name])
})

const _message = computed(() => {
  if(_form.value?.code?.error?.message) return _form.value?.code?.error?.message
  if(_errors.value && _errors.value[props.name] && _errors.value[props.name].length > 0) return _errors.value[props.name].join('\n')
  return "";
})
</script>

<template>
  <div :class="`cs-form-control ${showError ? 'error' : ''}`" v-bind="attrs">
    <slot></slot>
    <p v-if="showError" class="form-control-message">{{_message}}</p>
  </div>
</template>

<style lang="scss">
.cs-form-control{
  &.error{
    >.form-control{
      border: 1px solid red;
      color: red;
    }
    .account-picker__preview{
      border: 1px solid red;
    }
  }

  .form-control-message{
    margin-top: 7px;
    color: red;
    font-size: 12px;
  }
}
</style>
